// extracted by mini-css-extract-plugin
export default {"button":"styles_button__YcMrr","outlined":"styles_outlined__SQ0GJ"};